import { CurrentTierUsage } from 'api/clients/TierUsageClient'
import { useWebsocketConnection } from 'providers/WebsocketProvider'
import { useEffect } from 'react'

export interface Props {
  workspaceId: number
  onUpdate?: (tierUsage: CurrentTierUsage) => void
  onPlanUpdate?: () => void
}

interface TierUsageMessage {
  event: 'tier_usage_update' | 'plan_update'
  tier_usage: CurrentTierUsage
}

export const useTierUsageSubscription = ({ workspaceId, onUpdate, onPlanUpdate }: Props) => {
  const websocketConnection = useWebsocketConnection()

  useEffect(() => {
    if (!websocketConnection) return

    const subscription = websocketConnection.subscriptions.create(
      { channel: 'TierUsageChannel', workspace_id: workspaceId },
      {
        received: (message: TierUsageMessage) => {
          if (message.event === 'tier_usage_update') {
            const { tier_usage } = message
            onUpdate?.(tier_usage)
          } else if (message.event === 'plan_update') {
            onPlanUpdate?.()
          }
        },
      },
    )

    return () => {
      subscription.unsubscribe()
    }
  }, [workspaceId, websocketConnection, onUpdate, onPlanUpdate])
}
